export const AI_PROMPT_BOX_PLACEHOLDER =
  'Describe your business challenge or goal in detail';
export const AI_PROMPT_BOX_LABEL =
  'What business problem are you trying to solve?';
export const AI_PROMPT_BOX_DESCRIPTION =
  'Get tailored Chargebee API solutions.';
export const ARRAY_ITEM_NAME = '__array_item__';

export const PromptSuggestions = [
  'How to create a customer?',
  'How to fetch a subscription record from Chargebee',
  'How to retrieve a customer?',
];

export const LOCAL_STORAGE_LANG_KEY = 'cb-api-explorer-selected-language';
export const USECASE_IN_SEARCH_PARAM = 'use_case';
export const LANGUAGE_IN_SEARCH_PARAM = 'lang';
export const FORM_DATA_IN_SEARCH_PARAM = 'params';

// Sites where AI features are explicitly disabled
export const AI_BLOCKED_SITES = [
  'marvel-test',
  'marvel',
  'marvelsbx-test',
  'marvelsbx',
  'marvelqa-test',
  'marvelqa',
  'blacklist-test',
  'cb-ashik-test',
  'aero-ai-test',
];

export const urlSiteNameKey = 'site_name';
